import React, { useState } from "react";
import ProductInfo from "./ProductInfo";
import { KeyAspects } from "./KeyAspects";
import { ProductDescriptions } from "./ProductDescriptions";
import { FeaturesBenefits } from "./FeaturesBenefits";
import { LicensePrices } from "./LicensePrices";
import { ToolsUsed } from "./ToolsUsed";
import { KeyAspectsFonts } from "./KeyAspectsFonts";

export const DetailsTab = ({
  showFontsKeyAspects,
  data,
  setData,
  handleSubmit,
}) => {
  return (
    <div>
      <div className="md:flex md:space-x-4">
        <div className="md:w-3/4">
          <ProductInfo data={data} setData={setData} />
          {showFontsKeyAspects ? (
            <KeyAspectsFonts data={data} setData={setData} />
          ) : (
            <KeyAspects data={data} setData={setData} />
          )}

          <ProductDescriptions data={data} setData={setData} />
          <FeaturesBenefits data={data} setData={setData} />
        </div>
        <div className="md:w-1/2">
          <LicensePrices data={data} setData={setData} />
          <ToolsUsed data={data} setData={setData} />
        </div>
      </div>
    </div>
  );
};
